import { OutToTheEdgeOfCard } from 'components/shared/OutToTheEdgeOfCard';
import React from 'react';
import { Card, DataGrid, ISelectOption, StyledTagType } from 'ui-toolkit';
import { onEditCommentTypeSignature } from './EditCommentType';
import { eCommentType } from 'types/order/comment/eCommentType';
import { useGetCommentsTableColumns } from './hooks/useGetCommentsTableColumns';

export interface ICommentTableEntry {
  id: string;
  datePosted: string;
  commentType?: eCommentType;
  commentTypeColor?: StyledTagType;
  commentTypeDisplay: string;
  postedBy: string;
  content: string;
}

export interface ICommentsTableProps {
  comments?: ICommentTableEntry[];
  commentTypeOptions?: ISelectOption<eCommentType>[];
  onEditCommentType?: onEditCommentTypeSignature;
}

export const CommentsTable: React.FC<ICommentsTableProps> = ({ comments = [], ...rest }) => {
  const columns = useGetCommentsTableColumns({ comments, ...rest });

  return (
    <div className={'grow'}>
      <Card>
        <OutToTheEdgeOfCard>
          <DataGrid
            data={comments}
            defaultSorted={[{ dataField: 'datePosted', order: 'desc' }]}
            columns={columns}
            keyField={'id'}
            filter={true}
          />
        </OutToTheEdgeOfCard>
      </Card>
    </div>
  );
};
